import React from 'react';
import { motion } from 'framer-motion';

const Settings = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-playfair text-warm-brown mb-2">Settings</h2>
        <p className="text-warm-brown/70">Configure system preferences and options</p>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-xl shadow-lg p-6"
      >
        <h3 className="text-xl font-playfair text-warm-brown mb-4">System Settings</h3>
        <p className="text-warm-brown/70">Additional settings and configurations will be available here in future updates.</p>
        
        <div className="mt-8 p-4 bg-cream rounded-lg">
          <h4 className="text-lg font-medium text-warm-brown mb-2">Current Features</h4>
          <ul className="space-y-2 text-warm-brown/80">
            <li>• Theme customization and content management</li>
            <li>• User management and authentication</li>
            <li>• Real-time preview of changes</li>
            <li>• Local storage for data persistence</li>
          </ul>
        </div>
      </motion.div>
    </div>
  );
};

export default Settings;